<template>
  <div class="main-item main-setting">
    <div class="tabs">
      <a class="tab active" @click="tabChanger($event)">General</a>
      <a
        class="tab"
        @click="tabChanger($event)"
        v-if="$parent.activeSite.type=='webflow'"
      >Data Settings</a>
      <a class="tab" @click="tabChanger($event)">Collaborators</a>
    </div>
    <div v-if="tab=='General'" class="_700">
      <div class="field">
        <label class="item-label">Name</label>
        <input
          @change="updateUser('name',$event)"
          v-model="$parent.user.name"
          type="text"
          class="text-field w-input"
          placeholder="Full Name"
        />
      </div>
      <div class="field">
        <label class="item-label">Language</label>
        <select
          @change="updateUser('language',$event)"
          v-model="$parent.user.language"
          class="w-select"
        >
          <option>Pick a language</option>
          <option value="ltr">English</option>
          <option value="rtl">עברית</option>
        </select>
      </div>
      <div class="field">
        <label class="item-label">Theme</label>
        <select @change="updateUser('theme',$event)" v-model="$parent.user.theme" class="w-select">
          <option>Select a theme</option>
          <option value>Dark</option>
          <option value="light">Light</option>
        </select>
      </div>
      <div class="field">
        <a href="javascript:firebase.auth().signOut()" class="button w-button">Log Out</a>
      </div>
    </div>
    <div v-if="tab=='Data Settings'">
      <h3>Webflow Settings</h3>
      <div class="field">
        <p>Webflow API</p>
        <!-- <input v-model="$parent.access[0].token" class="text-field w-input"> -->
      </div>
      <a
        href="#"
        @click="getWebflowData()"
        v-if="$parent.collections.length"
        class="button w-button"
      >Get Data from webflow</a>
      <br />
      <br />
      <a href="#" @click="getWebflowSchema()" class="button w-button">
        Get Schema from webflow
        <Spinner :zoom="0.3" v-if="spinner.schema"></Spinner>
      </a>
    </div>
    <div v-if="tab=='Collaborators'" class="_700" @mounted="getCollaborators()">
      <div v-for="user in users" :key="user._id">
        {{user.name}}
        <hr style="opacity: 0.2; margin-bottom: 15px;margin-top: 15px" />
      </div>
    </div>
    <div @click="closePopup($event)" v-if="popup" class="popper" id="popper">
      <div class="popped">
        <div class="pops">
          <div class="check w-clearfix w-checkbox">
            <input type="checkbox" @change="selectAll($event)" id="selectAll" />
            <label class="checkbox-label w-form-label" for="selectAll">Select All</label>
          </div>
          <div v-for="collection in dataImport" :key="collection._id">
            <hr style="opacity: 0.2;" />
            <input
              :id="collection.slug"
              v-model="collection.include"
              true-value="yes"
              false-value="no"
              type="checkbox"
            />
            <label style="display:inline-block;" :for="collection.slug">{{collection.name}}</label>
          </div>
          <hr style="opacity: 0.2;" />
          <a href="#" @click="ImportData()" class="button w-button">
            Import Data
            <Spinner :zoom="0.3" v-if="spinner.data"></Spinner>
          </a>
          <p>{{importStatus}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/uiComponents/spinnerLoading.vue";
import { async } from "q";

export default {
  name: "settings",
  components: {
    Spinner
  },
  data() {
    return {
      users: [],
      tab: "General",
      freeze: false,
      importStatus: " ",
      popup: false,
      dataImport: [],
      spinner: {
        schema: false,
        data: false
      },
      allCollections: []
    };
  },
  mounted() {
    admindb
      .collection("/users/")
      .where(
        "access",
        "array-contains",
        admindb.doc("/sites/" + this.$parent.activeSite.siteID)
      )
      .get()
      .then(query => {
        query.forEach(doc => {
          var usr = doc.data();
          usr._id = doc.id;
          this.users.push(usr);
        });
      });
  },
  methods: {
    tabChanger(el) {
      $(".active").removeClass("active");
      $(el.target).addClass("active");
      this.tab = $(el.target).text();
    },
    selectAll(event) {
      if ($(event.target).prop("checked")) {
        var status = "yes";
      } else {
        status = "no";
      }
      $.each(this.dataImport, (i, e) => {
        e.include = status;
        Vue.set(this.dataImport, i, e);
      });
    },
    updateUser(field, event) {
      var val = event.target.value;
      admindb.doc("users/" + this.$parent.user.uid).update({
        [field]: val
      });
    },
    updateFirebase() {
      this.importStatus = "Sending to DB";
      var updated = 0;
      var AllItems = 0;
      $.each(this.dataImport, (i, e) => {
        if (e.items) {
          AllItems += e.items.length;
          var colID = e._id;
          $.each(e.items, (index, el) => {
            db.doc(`/collections/${colID}/items/${el._id}`)
              .set(el)
              .then(() => {
                updated++;
                this.importStatus = `Updated ${updated} of ${AllItems}`;
              });
          });
        }
      });
    },
    getItemsWebflow(i) {
      if (this.dataImport[i].include == "yes") {
        this.importStatus = "Importing " + this.dataImport[i].name;
        if (!this.dataImport[i].items) {
          this.dataImport[i].items = [];
        }
        var link =
          "https://cors.bagelstudio.co/api.webflow.com/collections/" +
          this.dataImport[i]._id +
          "/items?offset=" +
          this.dataImport[i].items.length +
          "&access_token=" +
          this.$parent.activeSite.token +
          "&api_version=1.0.0";
        $.get(link, response => {
          $.each(response.items, (index, el) => {
            this.dataImport[i].items.push(el);
          });
          if (response.total > this.dataImport[i].items.length) {
            this.getItemsWebflow(i, this.dataImport[i].items.length);
          } else {
            if (this.dataImport.length - 1 > i) {
              this.getItemsWebflow(i + 1);
            } else {
              this.spinner.data = false;
              this.updateFirebase();
            }
          }
        });
      } else {
        if (this.dataImport.length - 1 > i) {
          this.getItemsWebflow(i + 1);
        } else {
          this.spinner.data = false;
          this.updateFirebase();
        }
      }
    },
    ImportData() {
      this.getItemsWebflow(0);
      this.spinner.data = true;
    },
    getWebflowData() {
      this.dataImport = this.$parent.collections;
      this.popup = true;
    },
    closePopup(e) {
      if ($(e.target).closest(".popped").length == 0 && !this.freeze) {
        this.popup = false;
      }
    },
    async getCollectionSchemas(i) {
      this.spinner.schema = true;
      var link =
        "https://cors.bagelstudio.co/api.webflow.com/collections/" +
        this.allCollections[i]._id +
        "?access_token=" +
        this.$parent.activeSite.token +
        "&api_version=1.0.0";
      $.getJSON(link, async res => {
        this.allCollections[i].fields = res.fields;
        if (this.allCollections[i].name.match(/^\-/)) {
          this.allCollections[i].visible = false;
        } else {
          this.allCollections[i].visible = true;
        }
        if (this.allCollections.length - 1 > i) {
          this.getCollectionSchemas(i + 1);
        } else {
          this.allCollections = this.allCollections.sort((a, b) => {
            var aname = a.name.toLowerCase();
            var bname = b.name.toLowerCase();
            if (aname > bname) {
              return 1;
            } else if (aname < bname) {
              return -1;
            }
            return 0;
          });
          $.each(this.allCollections, async (i, e) => {
            var collection = await db
              .doc("collections/" + e._id)
              .set(e)
              .then(() => {
                if (i == this.allCollections.length - 1) {
                  this.spinner.schema = false;
                  this.$parent.getCollections();
                }
              });
          });
        }
      });
    },
    getWebflowSchema() {
      // get all collections
      var link =
        this.$parent.set.preLink +
        "sites/" +
        this.$parent.activeSite.siteID +
        "/collections" +
        "?access_token=" +
        this.$parent.activeSite.token +
        "&api_version=1.0.0";
      $.getJSON(link, res => {
        this.allCollections = res;
        this.getCollectionSchemas(0);
      });
    },
    getSchema(Col) {
      /*
            if (this.$parent.schemas[Col]) {
                $.each(this.$parent.schemas[Col],(i,e)=>{
                  this.schema.push(e)
                  if (this.isNew){
                      this.info[e.slug] = ''
                      this.loader = false
                  }
                })
            } else {
                */
      var link =
        this.$parent.set.preLink +
        "collections/" +
        Col +
        "/?access_token=" +
        this.$parent.set.token +
        "&api_version=1.0.0";
      this.$parent.schemas[Col] = {};
      $.getJSON(link, content => {
        window.schemadata = content.fields;
        $.each(content.fields, (i, e) => {
          if (
            e.name != "Created On" &&
            e.name != "Archived" &&
            e.name != "Draft" &&
            e.name != "Updated On" &&
            e.name != "Published On" &&
            e.name != "Created By" &&
            e.name != "Updated By" &&
            e.name != "Published By"
            //&& !e.name.match(/^-/)
          ) {
            this.schema.push(e);
            this.$parent.schemas[Col][e.slug] = e;
            if (this.isNew) {
              this.info[e.slug] = "";
              this.loader = false;
            }
          }
        });
      });

      //}
    }
  }
};
</script>

<style scoped>
.tabs {
  margin-bottom: 80px;
  margin-top: -100px;
  margin-left: -35px;
}
@media (max-width: 991px) {
  .tabs {
    margin-bottom: 80px;
    margin-top: -55px;
    margin-left: 0px;
  }
}
.tab {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 0px;
  border-left: none;
  padding: 20px 5%;
  /* border-bottom: 2px solid grey; */
}

.tab.active {
  /* border-bottom: 2px solid #3898ec; */
  background-color: #2d3035;
}

.light .tab.active {
  /* border-bottom: 2px solid #3898ec; */
  background-color: white;
}

.pops {
  width: 90vw;
  max-width: 720px;
  max-height: 90vh;
  overflow: auto;
  padding: 80px 60px;
  border-radius: 3px;
  background-color: #2d3035;
}
</style>
